// extracted by mini-css-extract-plugin
module.exports = {"checkboxLabel":"Checkbox_checkboxLabel__1S8UA","checkboxDefaultInput":"Checkbox_checkboxDefaultInput__3b9ei","checkboxCustomInput":"Checkbox_checkboxCustomInput__R7L0e"};